import React, { lazy } from 'react';

import { Typography } from 'components/ui';
import styled from 'styled-components';
import { useTheme } from '@mui/material/styles';

function AutocompleteOption(props, value) {
  const { name } = props;

  const theme = useTheme()

  return (
    <SItem>
      <SItemInfoWrap>
        <Typography
          variant="h5"
          style={{
            color: value.selected ? theme.palette.colors.white : theme.palette.colors.black,
          }}
        >
          {name}
        </Typography>
      </SItemInfoWrap>
    </SItem>
  );
}

export default AutocompleteOption;

const SItemInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px;
`;

const SItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  :hover {
    cursor: pointer;
  }
`;
